import React, {Fragment, useEffect, useState} from "react";
import customer from "../../network/services/customer";
import {getUserPhoneNumber} from "../../helpers/authenticator";
import DeliveryItem from "./DeliveryItem";
import general_helper from "../../helpers/general_helper";
import rider from "../../network/services/rider";
import Loader from "react-loaders";


const Deliveries = ({type}) => {
    // <Loader type="ball-scale-multiple"/>
    const [deliveries, setDeliveries] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let slicedToLastThree;


    // Show latest three deliveries
    if (deliveries.length > 3) {
        slicedToLastThree = deliveries.slice(0, 3);
    } else {
        slicedToLastThree = deliveries;
    }

    useEffect(() => {
        fetch(type);
    }, []);

    const fetch = (type) => {
        if (type === general_helper.deliveryType.rider) {
            rider.getRiderPendingDeliveries(getUserPhoneNumber()).then(response => {
                    setDeliveries([...deliveries, ...response.data.data]);
                    setIsLoading(false);
                }
            ).catch(error => {
                setIsLoading(false);
            });
        } else {
            customer.getDeliveries(getUserPhoneNumber()).then(response => {
                    setDeliveries([...deliveries, ...response.data.data]);
                    setIsLoading(false);
                }
            ).catch(error => {
                setIsLoading(false);
            });
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-6 text-left">
                    <p className="">
                        {type === general_helper.deliveryType.rider ? "Requests" : "Deliveries"}
                    </p>
                </div>
                <div className="col-6 text-right">
                    <a className="small-text-blue" href="/deliveries/history">
                        See All
                    </a>
                </div>
            </div>
            <br/>
            {
                isLoading ? <Loader type="ball-scale-multiple"/> : <>
                    {slicedToLastThree.map((item, index) => {
                        return (
                            <Fragment key={index}>
                                <ul className="list-unstyled">
                                    <li>
                                        <DeliveryItem key={index} delivery={{item: item, index: index, showCTA: true}}/>
                                    </li>
                                </ul>
                            </Fragment>
                        );
                    })}
                </>
            }


        </div>
    );
};

export default Deliveries;

